import React, { useEffect, useState } from 'react'
import Image from '../../../components/common/Image'
import Input from '../../../components/common/Input'
import Toggle from '../../../components/common/toggle'
import { GetCarBrands, GetCarModels, GetCarModelsByCarType } from '../../../api/system'
import Select from '../../../components/common/Select'
import { useNavigate } from 'react-router-dom'
import Notification from '../../../components/common/Error/Notification'
import moment from 'moment'
const Info = ({ info, parameters,data,onSubmit,service }) => {
  // const parameters = useSelector(state => state.global.parameters)
  // const user = useSelector(state => state.user)
  const navigate = useNavigate()
  // const [carBrand, setCarBrand] = useState([])
  // const [carModel, setCarModel] = useState([])
  const [userInfo, setUserInfo] = useState({plate_num: "" })
  const [error, setError] = useState({})
  const [modal, setModal] = useState(false)
  const [brandOption, setBrandOption] = useState(null)
  const btnDisabled = () => {
    let obj = { ...userInfo}
    let ins =(info?.offer_pnoname.indexOf("自費購")>-1 || info?.offer_pnoname.indexOf("道路救援險")>-1) && obj.ins_info
    if(error){
      Object.keys(error).forEach(key => {   
        delete obj[key]
        obj?.ins_info &&  delete obj.ins_info[key]
      })

    }
    let filter = Object.keys(obj).filter(o=>obj[o])
    let num = 7
    if(ins){
      return !(filter.filter(key => key!=='color').length > num &&
      Object.keys(obj.ins_info).length === 3)
    }else{
      
      return filter.filter(key => key!=='color').length < num 
    }
  }
  const fetchApi = async (types) => {
    let obj = {}
    for (let i = 0; i < types.length; i++) {
      let res = await GetCarModelsByCarType({ carType: types[i]['value'] })
      if (res?.statusCode === 200) {
        let result = res.result[0]
        obj[result.carType] = result.carBrandViewModels.map(car => {
          return ({ ...car.carBrand, name: `${car.carBrand.cnName || ""} ${car.carBrand.enName || ""}`, children: car.carModels })
        })
      }
    }
    setBrandOption(obj)
  }
  useEffect(() => {
    // GetCarBrands().then(res => {
    //   if (res?.statusCode === 200) {
    //     setCarBrand(res.result.map(r => ({ ...r, name: `${r.cnName} ${r.enName|| ''}`, value: r.brandId })))

    //   }
    // })
  }, []);
  const checkRegEx = (type, val, key, childrenObj) => {
    let reg = type==='name'? /^[A-Za-z\u4e00-\u9fa5]+$/ : null
    let error_obj = error || {}
    if(val && reg){
      let isValid = reg.test(val)
        if(isValid) {    
          delete error_obj[key] 
        }else{
          error_obj[key] = '請勿輸入數字或符號。'
        }
    }
    if(!val) delete error_obj[key] 
    setError(error_obj)
    if(childrenObj){
      let obj = userInfo?.[childrenObj]|| {}
      obj[key] = val
      setUserInfo({ ...userInfo, [childrenObj]: obj })
    }else{
      setUserInfo({ ...userInfo, [key]: val })
    }
  }
  useEffect(() => {
    if (parameters) {
      let obj = { ...userInfo }
      obj.type = parameters.CarType.data[0]
      if (info)  {

        obj.plate_num = info.car_no
        if(info.info){
          const { name,phoneNum } = info.info
          obj.name = name
          obj.phone01 = phoneNum
          obj.phone02 = phoneNum
          if(info?.offer_pnoname.indexOf("自費購")>-1 || 
          info?.offer_pnoname.indexOf("道路救援險")>-1){
            obj.ins_info ={
              driver_name:name
            }
          }
        }
      }
      if(data) {
        obj=data
      }
      fetchApi(parameters.CarType?.data)
      setUserInfo(obj)
    }
  }, [parameters, info,data])
  return (
    <div className='container'>
      <div className="page-header">
        <button className="btn-circle" onClick={() => setModal("close")}>
          <Image src="/images/icons/close.svg" svg />
        </button>
        <div className="page_header__title">
          <h1 className="font-heading">基本資料</h1>
          <p className="text-secondary text-scale-02">
            部分欄位優惠身份會自行帶入
          </p>
        </div>
      </div>
      <div className='grid-gap-24'>
      {
        (info?.offer_pnoname.indexOf("自費購")>-1 || info?.offer_pnoname.indexOf("道路救援險")>-1)?(<>
            <Input
            defaultValue={userInfo.ins_info?.driver_name}
            label='姓名'
            placeholder="請輸入證件本名以利後續優惠核定"
            error={error?.driver_name}
            errorText={error?.driver_name}
            onChange={(val) => {
              checkRegEx("name",val,'driver_name','ins_info')
              // let ins_info = userInfo.ins_info?userInfo.ins_info:{}
              // if(val){
              //   ins_info.driver_name= val
              // }else{
              //   delete ins_info.driver_name
              // }
              // setUserInfo({ ...userInfo ,ins_info})
            }}
            // rules={[{ pattern: new RegExp(/^[\u4e00-\u9fa5a-zA-Z\s]+$/), message: '請勿輸入數字或符號。' }]}
            
          />
           <Input
            defaultValue={userInfo.ins_info?.driver_id}
            label='身分證號碼'
            placeholder="請輸入身份證號碼以利後續優惠核定"
            onChange={(val) => {
              let ins_info = userInfo.ins_info?userInfo.ins_info:{}
              if(val){
                ins_info.driver_id= val
              }else{
                delete ins_info.driver_id
              }
              setUserInfo({ ...userInfo ,ins_info})
            }}
            rules={[{ pattern: new RegExp(/^[A-Z][1-2]\d{8}$/), message: '身分證格式錯誤，請輸入正確格式' }]}
            
          />
          <Input
            defaultValue={userInfo.ins_info?.driver_birthday}
            label='生日'
            type='date'
            placeholder="請輸入生日以利後續優惠核定"
            max={moment().format('YYYY-MM-DD')}
            onChange={(val) => {
              let ins_info = userInfo.ins_info?userInfo.ins_info:{}
              if(val){
                ins_info.driver_birthday= val
              }else{
                delete ins_info.driver_birthday
              }
              setUserInfo({ ...userInfo ,ins_info})
            }}
          />
        </>):(
         <></>
        )
      }
      <Input
          defaultValue={userInfo.name}
          label='稱呼方式'
          placeholder="我們該如何稱呼您"
          error={error?.name}
          errorText={error?.name}
          onChange={(val) =>   checkRegEx("name",val,'name')}
          // rules={[{ pattern: new RegExp( /^[A-Za-z\u4e00-\u9fa5]+$/), message: '請勿輸入數字或符號。' }]}
        />
        <div>
          <Input
          defaultValue={userInfo.phone01}
            error={error?.phone02}
            label={<>
              <p>手機號碼</p>
              <p className='text'>技師媒合成功會透過手機與您聯繫，請輸入可保持暢通之手機號碼</p>
            </>}
            placeholder="請輸入您的手機號碼"
            rules={
              [{ pattern: new RegExp(/^[0-9]+$/), message: '請輸入半形數字，不需包含「-」符號。' }]
              }
            onChange={(val) => {
              if (val !== userInfo.phone02) {
                setError({phone01:"請再次確認欄位內容"})
              } else {
                setError({})
                
              }
              setUserInfo({ ...userInfo, phone01: val })
            }}
            
          />
          <Input
            defaultValue={userInfo.phone02}
            error={error?.phone02}
            errorText={error?.phone02}
            style={{ marginTop: 8 }}
            placeholder="請再次輸入手機號碼"
            rules={[{ pattern: new RegExp(/^[0-9]+$/), message: '請輸入半形數字，不需包含「-」符號。' }]}
            onChange={(val) => {
              if (val !== userInfo.phone01) {
                setError({phone02:"請再次確認欄位內容"})
                delete userInfo.phone02
              } else {
                setError({})
                setUserInfo({ ...userInfo, phone02: val })
              }
            }}
          />
        </div>
        {
          parameters && (
            <Toggle 
              label='車輛類型'
              list={parameters.CarType.data}
              defaultValue={userInfo.type}
              onChange={(data) => {
                let obj = { ...userInfo }
                obj.type = data
                delete obj.brand
                delete obj.model
                setUserInfo(obj)
              }} />
          )
        }
        <Input
          label="車牌號碼"
          placeholder="請輸入您的車牌號碼"
          defaultValue={info ? `${info.car_no}（不可變更）` : userInfo.plate_num}
          disabled={info}
          rules={
                    !info && [{ pattern: new RegExp(/^[a-zA-Z0-9]*$/), message: '請輸入半形英數字，不需包含「-」符號。' }]
                }
          onChange={(e) => setUserInfo({ ...userInfo, plate_num: e })}
        />
        <Select
          label='車輛廠牌'
          placeholder="點擊選擇"
          defaultValue={userInfo.brand}
          search
          options={brandOption?.[userInfo.type.value] || []}
          onChange={(data) => {
            let obj = { ...userInfo }
            obj.brand = data
            delete obj.model
            // setUserCar(obj)
            setUserInfo(obj)
            // GetCarModels({ brandid: data.brandId }).then(res => {
            //   if (res?.statusCode === 200) {
            //     setCarModel(res.result.map(r => ({ ...r })))
            //   }
            // })
          }}
        />
        <Select
          label='車型'
          placeholder="點擊選擇"
          defaultValue={userInfo.model}
          nameKey="modelName"
          search
          options={userInfo.brand?.children || []}
          onChange={(data) => {
  
            //電車 選擇“接電”服務
            if(data.isNoElectricity && service=== '4'){
              setModal("isNoElectricity")
            }
            setUserInfo({...userInfo, model:data})

          }}
        />
        <Input
          label="車身顏色(非必填)"
          placeholder="例）白色"
          onChange={(val) => {
            // setUserCar({ ...userCar, color: val })
            setUserInfo({ ...userInfo, color: val })
          }}
        />
        <button
          className='btn'
          disabled={btnDisabled()}
          onClick={()=>onSubmit(userInfo)}
        >確認</button>
      </div>
      {
        modal && (
          <Notification title={modal === 'close'?'要離開了嗎？':'此車型無法接電'}
            description={modal === 'close'?'案件尚未成立，剛剛填入的資料將不會保存':'此車型不建議接電，將服務請改拖吊服務'}
            btn02Text={modal === 'close'?'確定離開':'開始拖吊'}
            okText={modal === 'close'?'繼續填寫':'變更車型'}
            onConfirm={() => {
              if(modal !== 'close'){
                //變更車型
                let obj ={ ...userInfo }
                delete obj.model
                delete obj.brand
                setUserInfo(obj)
              }
              setModal(false)

            }}
            onBnt02={() => {
              if(modal === 'close'){
                navigate('/services')
              }else{
                navigate('/add?service=1')
                setModal(false)
              }
            }}
          />
        )
      }
    </div>
  )
}

export default Info